<template>
  <div class="animated fadeIn">
    <basic-heading title="Manage Schedule Samples" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <schedule-sample-cohort-form :schedule_id="schedule_id" />
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import ScheduleSampleCohortForm from "@/components/lab/schedule/form/ScheduleSampleCohortForm";

export default {
  name: "ScheduleCohort",

  components: {
    BasicHeading,
    HeaderButtonGroup,
    ScheduleSampleCohortForm,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            title: "To Schedule list",
            variant: "primary",
            linkto: "/schedules/",
          },
          {
            icon: "fa-calendar",
            title: "From Previous Schedule",
            variant: "info",
            linkto: `/schedules/${this.schedule_id}/previous-schedules`
          },
          {
            icon: "fa-eye",
            title: "To Schedule",
            variant: "info",
            linkto: `/schedules/${this.schedule_id}`,
          },
          {
            icon: "fa-tools",
            variant: "warning",
            title: "Manage Schedule",
            linkto: `/schedules/${this.schedule_id}/schedule-samples`,
          },
        ],
      };
    },
  },
  data() {
    return {
      schedule_id: this.$route.params.schedule_id || null,
    };
  },
};
</script>
